import { useEffect, useState } from "react";
import { Drawer, DrawerContent } from "@/components/ui/drawer";
import ProductCard from "./product-card";
import { cloneNode } from "../ui-script/utils";

type Category = {
  complementary: string[];
  mono: string[];
  analogous: string[];
  tonal: string[];
};

export function HeliumDrawer({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(true);

  return (
    <Drawer open={open} onOpenChange={(isOpen) => setOpen(isOpen)}>
      <DrawerContent className="hp-rounded-none hp-pb-2">{children}</DrawerContent>
    </Drawer>
  );
}

export function ProductCardLoader() {
  return (
    <div className="hp-flex hp-w-full hp-flex-row hp-gap-2 hp-overflow-hidden hp-px-2 hp-py-2">
      {new Array(4).fill(0).map((_, i) => (
        <div className="hp-shimmer hp-h-48 hp-w-48 hp-bg-gray-200" key={i} />
      ))}
    </div>
  );
}
